var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoadingSpinner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "68px",
    height: "68px",
    viewBox: "0 0 68 68",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "loading-spinner") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.892%",
    y1: "58.241%",
    x2: "55.03%",
    y2: "89.889%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A7274",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F9093",
    stopOpacity: 0.59,
    offset: "22.44%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "loading-spinner",
    transform: "translate(0.058875, 0.058875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.9411255,57.9411255 C20.6862915,57.9411255 9.9411255,47.1959595 9.9411255,33.9411255 C9.9411255,20.6862915 20.6862915,9.9411255 33.9411255,9.9411255 C47.1959595,9.9411255 57.9411255,20.6862915 57.9411255,33.9411255 C57.9411255,47.1959595 47.1959595,57.9411255 33.9411255,57.9411255 Z M33.9411255,53.9411255 C44.9868205,53.9411255 53.9411255,44.9868205 53.9411255,33.9411255 C53.9411255,22.8954305 44.9868205,13.9411255 33.9411255,13.9411255 C22.8954305,13.9411255 13.9411255,22.8954305 13.9411255,33.9411255 C13.9411255,44.9868205 22.8954305,53.9411255 33.9411255,53.9411255 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9411255,33.9411255 C57.9411255,35.045695 57.045695,35.9411255 55.9411255,35.9411255 C54.836556,35.9411255 53.9411255,35.045695 53.9411255,33.9411255 C53.9411255,22.8954305 44.9868205,13.9411255 33.9411255,13.9411255 C22.8954305,13.9411255 13.9411255,22.8954305 13.9411255,33.9411255 C13.9411255,44.9868205 22.8954305,53.9411255 33.9411255,53.9411255 C35.045695,53.9411255 35.9411255,54.836556 35.9411255,55.9411255 C35.9411255,57.045695 35.045695,57.9411255 33.9411255,57.9411255 C20.6862915,57.9411255 9.9411255,47.1959595 9.9411255,33.9411255 C9.9411255,20.6862915 20.6862915,9.9411255 33.9411255,9.9411255 C47.1959595,9.9411255 57.9411255,20.6862915 57.9411255,33.9411255 Z",
    id: "Path",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero",
    transform: "translate(33.941125, 33.941125) rotate(45.000000) translate(-33.941125, -33.941125) "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingSpinner);
export default __webpack_public_path__ + "static/media/loading-spinner.cbd74e4cafff6857184299f7692acc95.svg";
export { ForwardRef as ReactComponent };